import React from 'react';
import '../styles/components.css';

const SectionHeader = ({ title, subtitle, className = '' }) => {
  return (
    <div className={`section-header ${className}`}>
      {title && <h2>{title}</h2>}
      {subtitle && <p>{subtitle}</p>}
    </div>
  );
};

export default SectionHeader;
